import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApplicationStateService } from '@core/service';
import { API_URL } from '@core/constants';
import { Observable } from 'rxjs';
import { IAdverseDeterminationDTO, IPds, IUrgentNotification } from '@core/model';

@Injectable()
export class AdverseDeterminationService {
  private pds: IPds[] | null = null;
  private urgentNotifications: IUrgentNotification[] | null = null;

  private get tenantId() {
    return this.applicationStateService.tenantId
  };

  constructor(
    public http: HttpClient,
    private applicationStateService: ApplicationStateService,
    @Inject(API_URL) private apiUrl: string
  ) {}

  /**
   * Check if Adverse Determination exists for Product Line
   * @param authorizationId - authorizationByProductId
   * @param id - productLineId of origin Product Line
   * @description Permission: AdverseDetermination.Read
   */
  exists(authorizationId: string, id: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.adverseDeterminationsAPIUrl(authorizationId, id)}/exists`);
  }

  /**
   * Get Adverse Determination for Product Line
   * @param authorizationId - authorizationByProductId
   * @param id - productLineId of origin Product Line
   * @description Permission: AdverseDetermination.Read
   */
  get(authorizationId: string, id: string): Observable<IAdverseDeterminationDTO> {
    return this.http.get<IAdverseDeterminationDTO>(`${this.adverseDeterminationsAPIUrl(authorizationId, id)}`);
  }

  /**
   * Create Adverse Determination
   * @param authorizationId - authorizationByProductId
   * @param id - productLineId of origin Product Line
   * @description Permission: AdverseDetermination.Create
   */
  create(authorizationId: string, id: string): Observable<IAdverseDeterminationDTO> {
    return this.http.post<IAdverseDeterminationDTO>(
      this.adverseDeterminationsAPIUrl(authorizationId, id),
      null
    );
  }

  /**
   * Update Adverse Determination
   * @param authorizationId - authorizationByProductId
   * @param id - productLineId of origin Product Line
   * @param payload
   * @description Permission: AdverseDetermination.Update
   */
  update(authorizationId: string, id: string, payload: IAdverseDeterminationDTO): Observable<IAdverseDeterminationDTO> {
    return this.http.put<IAdverseDeterminationDTO>(`${this.adverseDeterminationsAPIUrl(authorizationId, id)}`, payload)
  }

  resetSubTabData() {
    this.pds = null;
    this.urgentNotifications = null;
  }

  private adverseDeterminationsAPIUrl(authorizationId: string, productLineId: string): string {
    const baseUrl = `${this.apiUrl}/api/tenants/${this.tenantId}/authorizations`;
    return `${baseUrl}/${authorizationId}/productLines/${productLineId}/AdverseDeterminations`;
  }
}
